import React from 'react';

const  Heading3 = (props) => {

    const {
        children,
        color,
        classe
    } = props

    let h3Color
    if(color === "secondary") h3Color = "text-secondary"
    else h3Color = "text-primary"

    return (
        <h3 className={`
            ${h3Color}
            text-xl
            md:text-2xl
            font-primary
            font-semibold
            leading-snug
            ${classe}
        `}>
            { children }
        </h3>
    );
}

export default Heading3;